/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../common";
import type { WBANToken, WBANTokenInterface } from "../../contracts/WBANToken";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "banAddress",
        type: "string",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "SwapToBan",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MINTER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PAUSER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "uuid",
        type: "uint256",
      },
    ],
    name: "isReceiptConsumed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "uuid",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "mintWithReceipt",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "bananoAddress",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "swapToBan",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type WBANTokenConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: WBANTokenConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class WBANToken__factory extends ContractFactory {
  constructor(...args: WBANTokenConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<WBANToken> {
    return super.deploy(overrides || {}) as Promise<WBANToken>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): WBANToken {
    return super.attach(address) as WBANToken;
  }
  override connect(signer: Signer): WBANToken__factory {
    return super.connect(signer) as WBANToken__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): WBANTokenInterface {
    return new utils.Interface(_abi) as WBANTokenInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): WBANToken {
    return new Contract(address, _abi, signerOrProvider) as WBANToken;
  }
}
